/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TMarkOffersAsViewedRequest,
  TMarkOffersAsViewedModel,
  IMappers,
  TMarkOffersAsViewedResponse,
  TMarkOffersAsViewedResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createMarkOffersAsViewedModel(parameters: TMarkOffersAsViewedRequest): TMarkOffersAsViewedModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'viewed-offers',
    pathApi: '/v1/mark-offers-as-viewed/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IMarkOffersAsViewedOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TMarkOffersAsViewedRequest;
}

export async function fetchMarkOffersAsViewed<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IMarkOffersAsViewedOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TMarkOffersAsViewedResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createMarkOffersAsViewedModel(parameters),
    config,
  )) as FetchResponse<TMarkOffersAsViewedResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TMarkOffersAsViewedResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TMarkOffersAsViewedResponse>;
}
